/* eslint-disable import/no-named-as-default-member */

import i18n from 'i18next'
import HttpApi from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { isDev, isProductionHost } from 'lib/env'
import XRay from 'lib/utils/i18next/i18nXray'

const loggedKeys = []

const defaultLanguage = 'fi'
export const languages = ['en', 'fi']

const detectorOptions = {
    order: ['cookie'],
    lookupCookie: 'lang'
}

i18n
    .use(HttpApi)
    .use(LanguageDetector)
    .use(initReactI18next)
    .use(XRay)
    .init({
        fallbackLng: defaultLanguage,
        whitelist: languages,
        nonExplicitWhitelist: false,
        detection: detectorOptions,
        ns: ['common', 'inflection'],
        defaultNS: 'common',
        debug: false,
        interpolation: {
            escapeValue: false,
        },
        react: {
            bindI18n: 'languageChanged',
            bindStore: false,
            transEmptyNodeValue: '',
            // transSupportBasicHtmlNodes: true,
            // transKeepBasicHtmlNodesFor: ['br', 'strong', 'b', 'i'],
        },
        parseMissingKeyHandler: (key) => {
            // make sure to log only one entry per session to not flood logging
            if (!loggedKeys[key]) {
                loggedKeys[key] = true
                const msg = `react-i18next key "${key}" not found.`
                if (isDev()) {
                    console.warn(msg)
                } else {
                    // Disable logging until current issues fixed.
                    // Should be enabled again after this is done:
                    // https://trello.com/c/GQokA3eJ/1930-go-thru-missing-translation-keys
                    // logException(new Error(msg))
                }
            }
            return key
        },
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json?' + __webpack_hash__, // eslint-disable-line
            withCredentials: true,
        },
        postProcess: isProductionHost() ? [] : ['xray'],
    })

export default i18n
